import { useEffect, useState } from "react";

import ModalMotion, {
  AnimateDirection,
} from "@/components/Molecules/ModalMotion";

import TrialCallbackForm from "./TrialCallbackForm";
import CallbackSuccess from "../../CallbackModal/CallbackSuccess";

import { classNameGenerator, clsx } from "@/utils";

import styles from "./TrialCallbackModal.module.scss";

interface TrialCallbackModalProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

const TrialCallbackModal: React.FC<TrialCallbackModalProps> = ({
  showModal,
  setShowModal,
}) => {
  const cls = classNameGenerator(styles);

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isFormSubmitted) {
      timer = setTimeout(() => {
        setIsFormSubmitted(false);
        setShowModal(false);
      }, 5000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isFormSubmitted, setShowModal]);

  return showModal ? (
    <ModalMotion
      overlayClosable
      onClose={() => setShowModal(false)}
      width="520px"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      className={clsx(
        cls("trialCallbackModal"),
        isFormSubmitted
          ? cls("callbackSuccessWrapper")
          : cls("callbackFormWrapper")
      )}
    >
      {isFormSubmitted ? (
        <CallbackSuccess />
      ) : (
        <TrialCallbackForm setIsFormSubmitted={setIsFormSubmitted} />
      )}
    </ModalMotion>
  ) : (
    <></>
  );
};

export default TrialCallbackModal;
